import styled from "styled-components";

export const SearchFieldContainer = styled.div`
  width: 100%;
  position: relative;
  background-color: ${(props) => props.theme.colors.white};
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 8px 12px;
    border-radius: 4px;
    
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    
    font-size: 14px;
    font-weight: 500;

    &:hover{
        background-color: ${(props) => props.theme.colors.primary};
    }
`;

export const ContentButton = styled.div`
    display: flex;
    gap: 4px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    
    padding: 0px 10px;
    
    &.border-bottom{
        border-radius: 0px;
        border: none;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    }
    
    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const EmptyList = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;

    &::-moz-focus-inner{
        border: 1px solid red;
    }
    
    &.input-border-none{
        border: none;
        padding: 10px 0px;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const PopMenu = styled.div`
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    width: 100%;
    max-width: 100%;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 5px 3px;

    max-height: 250px;
    overflow-y: scroll;


    &::-webkit-scrollbar { 
        display: none;
    }

    span{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};
        padding: 5px 10px;
    }
`;

export const ButtonMenu = styled.button`
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
  }
  &.orange{
      color: ${(props) => props.theme.colors.warning};
        svg{
        }
    }
    &.red{
        color: ${(props) => props.theme.colors.error};
        svg{
        }
    }
    &.green{
        color: ${(props) => props.theme.colors.success};
        svg{
        }
    }
`;
//Fim PopMenu